import { Button } from "@dash/form";
import { SectionHeader } from "@dash/page";
import { useTheme } from "@emotion/react";
import type { FC } from "react";

import { useClientManager } from "@megaron/react-clients";
import { TicketsQueryQs } from "@megaron/support-contracts";
import { Uuid } from "@megaron/uuid";

import { CustomerSupportCreateTicketDialog } from "./CustomerSupportCreateTicketDialog";
import { CustomerSupportTicketsCards } from "./CustomerSupportTicketsCards";
import { useCustomerSupportCreateTicketForm } from "./useCustomerSupportCreateTicketForm";

type Props = {
  customerUuid: Uuid;
  defaultReporterEmail: string;
  defaultReporterName: string;
};

export const CustomerSupportTicketsList: FC<Props> = ({
  customerUuid,
  defaultReporterEmail,
  defaultReporterName,
}) => {
  const theme = useTheme();
  const ticketsListQuery: TicketsQueryQs = {
    offset: 0,
    limit: 50,
    searchText: undefined,
    status: undefined,
    priority: undefined,
    tags: undefined,
    sort: "createdAt",
    sortOrder: "desc",
    myTickets: undefined,
    isRead: undefined,
    contactEmail: undefined,
    customerUuid: customerUuid,
  };

  const ticketsQuery = useClientManager("support").ticketsList().useQuery(ticketsListQuery);

  const createForm = useCustomerSupportCreateTicketForm({
    customerUuid,
    defaultReporterEmail,
    defaultReporterName,
    ticketsListQueryKey: ticketsQuery.key,
  });

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
      <SectionHeader
        isHr
        css={{ marginTop: "0", h2: { color: theme.colors.primary } }}
        actions={
          <Button
            variant="outline"
            css={{ fontSize: "12px", padding: "4px 8px" }}
            onClick={() => createForm.setIsDialogOpen(true)}
          >
            Dodaj
          </Button>
        }
      >
        Zgłoszenia
      </SectionHeader>
      <CustomerSupportTicketsCards ticketsQuery={ticketsQuery} />
      {createForm.isDialogOpen && (
        <CustomerSupportCreateTicketDialog
          onClose={createForm.closeDialog}
          subject={createForm.subject}
          onSubjectChange={createForm.setSubject}
          message={createForm.message}
          onMessageChange={createForm.setMessage}
          sourceMailbox={createForm.sourceMailbox}
          onSourceMailboxChange={createForm.setSourceMailbox}
          mailboxOptions={createForm.mailboxOptions}
          mailboxesQuery={createForm.mailboxesQuery}
          selectedContact={createForm.selectedContact}
          onContactSelectChange={createForm.onContactSelectChange}
          contactOptions={createForm.contactOptions}
          onSubmit={createForm.handleCreateTicket}
          isBusy={createForm.isBusy}
        />
      )}
    </div>
  );
};
